
// 教练管理-教练信息详情编辑us-coach-detail
const CoachDetails = () => import(/* webpackChunkName: "CoachDetails" */ '@/components/event/coach-details.vue')

// 教练管理-站教练信息详情编辑
const USCoachDetails = () => import(/* webpackChunkName: "CoachDetails" */ '@/components/event/us-coach-detail.vue')
// 报名记录
const RegistrationRecord = () => import(/* webpackChunkName: "RegistrationRecord" */ '@/components/event/registration-record.vue')

// 团队信息
const TeamInfo = () => import(/* webpackChunkName: "TeamInfo" */ '@/components/event/team-info.vue')

// 任务进度
const ProgressTask = () => import(/* webpackChunkName: "ProgressTask" */ '@/components/event/progress-task.vue')

// USADP教练组队
const USADPInfo = () => import(/* webpackChunkName: "USADPInfo" */ '@/components/event/usadp-info.vue')

const JobRecords = () => import(/* webpackChunkName: "USADPInfo" */ '@/components/event/JobRecords.vue')

const JobDetials = () => import(/* webpackChunkName: "USADPInfo" */ '@/components/event/JobDetials.vue')

// USADP 教练端公告
const USADPCoachFiles = () => import(/* webpackChunkName: "USADPCoachFiles" */ '@/components/event/usadp-coach-files.vue')

// USADP 公告详情
const NoticeDetails = () => import(/* webpackChunkName: "NoticeDetails" */ '@/components/event/notice-details.vue')

// USADP 公告详情
const GradleDetails = () => import(/* webpackChunkName: "NoticeDetails" */ '@/components/event/gradle-details.vue')

// USADP 公告详情
const LocalGradleDetails = () => import(/* webpackChunkName: "NoticeDetails" */ '@/components/event/local-gradle-details.vue')
// 准考证
const AdmissionTicket = () => import(/* webpackChunkName: "NoticeDetails" */ '@/components/event/AdmissionTicket.vue')

export default [
  // 任务进度查询
  {
    path: '/Event/ProgressTask',
    name: 'ProgressTask',
    component: ProgressTask
  },
  // 学校管理-教练信息详情编辑USCoachDetails
  {
    path: '/Event/CoachDetails',
    name: 'CoachDetails',
    component: CoachDetails
  },
  // 学校管理-找教练信息详情编辑
  {
    path: '/Event/USCoachDetails',
    name: 'USCoachDetails',
    component: USCoachDetails
  },
  // 报名记录
  {
    path: '/Event/RegistrationRecord',
    name: 'RegistrationRecord',
    component: RegistrationRecord
  },
  // 报名记录
  {
    path: '/Event/TeamInfo',
    name: 'TeamInfo',
    component: TeamInfo
  },
  // USADP教练组队记录
  {
    path: '/Event/USADPInfo',
    name: 'USADPInfo',
    component: USADPInfo
  },
  {
    path: '/Event/JobRecords',
    name: 'JobRecords',
    component: JobRecords
  },
  {
    path: '/Event/JobDetials',
    name: 'JobDetials',
    component: JobDetials
  },
  // USADP 教练端公告
  {
    path: '/Event/USADPCoachFiles',
    name: 'USADPCoachFiles',
    component: USADPCoachFiles
  },
  // 公告编辑
  {
    path: '/Event/NoticeDetails',
    name: 'NoticeDetails',
    component: NoticeDetails
  },
  {
    path: '/Event/GradleDetails',
    name: 'GradleDetails',
    component: GradleDetails
  },
  {
    path: '/Event/LocalGradleDetails',
    name: 'LocalGradleDetails',
    component: LocalGradleDetails
  },
  {
    path: '/Event/AdmissionTicket',
    name: 'AdmissionTicket',
    component: AdmissionTicket
  }
]



// WEBPACK FOOTER //
// ./src/router/index-event.js